
// `value` is the stable code sent to the API/history; `labelKey` resolves the
// display label through i18n (t(labelKey)).
const objectiveList = [
    { labelKey: 'translator.objective.general', value: 'general' },
    { labelKey: 'translator.objective.learning', value: 'learning' },
    { labelKey: 'translator.objective.business', value: 'business' },
    { labelKey: 'translator.objective.social', value: 'social' },
    { labelKey: 'translator.objective.travel', value: 'travel' }
];

export default objectiveList
